import React, { useId } from "react";
import { Button } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Swal from "sweetalert2";

const FileUploadInput = ({ file, onChange }) => {
  const inputId = useId();

  const handleFileSelect = (e) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    if (selectedFile.type !== "application/pdf") {
      Swal.fire({
        icon: "warning",
        title: "Archivo no permitido",
        text: "Solo se permiten archivos en formato PDF.",
        confirmButtonColor: "#1ab394",
      });
      e.target.value = "";
      return;
    }

    onChange(selectedFile);
  };

  return (
    <>
      <input
        type="file"
        accept="application/pdf"
        hidden
        id={inputId}
        onChange={handleFileSelect}
      />

      <label htmlFor={inputId}>
        <Button
          variant="outlined"
          component="span"
          size="small"
          startIcon={<UploadFileIcon />}>
          {file ? "Cambiar PDF" : "Subir PDF"}
        </Button>
      </label>
    </>
  );
};

export default FileUploadInput;
